import { render, staticRenderFns } from "./DocumentSeriesTypeFormModal.vue?vue&type=template&id=d4fd4d0a&"
import script from "./DocumentSeriesTypeFormModal.vue?vue&type=script&lang=js&"
export * from "./DocumentSeriesTypeFormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports